import Vue from 'vue';
import constants from '../../../../constants';

Vue.filter('formatPrice', function(value = 0, currency = null) {
  const locale = constants.SUPPORTED_LOCALES[Vue.prototype.$lng] || constants.SUPPORTED_LOCALES[constants.DEFAULT_LANGUAGE];
  const formatted = value.toLocaleString(locale, { minimumFractionDigits: 2 });

  switch (currency) {
    case 'eur':
      return `${formatted} €`;
    default:
      return formatted;
  }
});
